import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import VideoViewsModule from 'components/organisms/social/VideoViewsModule';

class VideoViewsContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'VIDEO_VIEWS' } = {}) {
        super(props, objective);
    }


    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialCalloutsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
    }

    render() {
        return (
            <VideoViewsModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.VIDEO_VIEWS,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
})(VideoViewsContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/VideoViewsContainer.js